module.exports = __webpack_public_path__ + "media/packs/images/flags/SY-e5f797518557e54a485a18377cefe9be.png";